import { render } from "./MissedStep.vue?vue&type=template&id=88bbefda&scoped=true"
import script from "./MissedStep.vue?vue&type=script&lang=js"
export * from "./MissedStep.vue?vue&type=script&lang=js"

import "./MissedStep.vue?vue&type=style&index=0&id=88bbefda&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88bbefda"]])

export default __exports__